import { render, staticRenderFns } from "./PostgraduateSubjectsSearch.vue?vue&type=template&id=06e2b183&scoped=true"
import script from "./PostgraduateSubjectsSearch.vue?vue&type=script&lang=js"
export * from "./PostgraduateSubjectsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e2b183",
  null
  
)

export default component.exports